import React, {Component, Fragment} from 'react';
import ReactDOM from "react-dom";
import BookingContainer from "./Booking/BookingContainer";
import SelectRoom from "./Booking/SelectRoom/SelectRoom";
import Grid from "@mui/material/Grid";
import SummaryContainer from "./Booking/Summary/SummaryContainer";
import {getRandomInt, getStepsBooking, requestLoader, showAlertAutoDis, redirectTo} from "../utils/utils";
import Review from "./Booking/Review/Review";
import TripSummary from "./Booking/Summary/TripSummary";
import ContactForm from "./Booking/Information/ContactForm";
import TermsConditions from "./Booking/Terms/TermsConditions";
import Payment from "./Booking/Payment/Payment";
import HoldBook from "./Booking/Payment/HoldBook";
import * as yup from "yup";
import Confirmation from "./Booking/Confirmation/Confirmation";
import PaymentModal from "./Booking/Payment/PaymentModal";
import { encode, decode } from 'js-base64';
import { format } from 'date-fns';
import {createTheme, Typography} from "@mui/material";
import MoreInfoModal from "./Booking/Information/MoreInfoModal";
import {mapValues} from "lodash";
import Activities from "./Booking/Confirmation/Activities";
import Itinerary from "./Booking/Summary/Itinerary";
import {ThemeProvider} from "@mui/material/styles";
// import red from '@mui/material/colors/red';
// import createPalette from "@mui/material/styles/createPalette";

const theme = createTheme({
    palette: {
        primary: {
            main: '#00b7f0',
            dark: '#11486e'
        },
        secondary: {
            main: '#19857b',
        },
        error: {
            main: '#750829',
        },
        default: {
            main: '#123456'
        }
    }
});

const templateContent = (mod, summary) => {
    return (
        <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={summary?9:12}>
                {mod}
            </Grid>
            {summary && <Grid item xs={12} sm={12} md={3}>
                {summary}
            </Grid>}
        </Grid>
    );
};
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
let signup = yup.object().shape({
    firstName: yup.string().required('The first name is required'),
    lastName: yup.string().required('The last name is required'),
    email: yup.string().email('you need to enter a valid email').required('The email is required'),
    telephone: yup.string().matches(phoneRegExp, 'Phone number is not valid').required('The telephone is required'),
    password: yup.string().required('The password is required'),
    confirmPassword: yup.string().oneOf([yup.ref('password'), null], 'Passwords must match').required('The Confirm password is required'),
    howdidyouhear: yup.string().required('How did you hear about us? Please select a valid option'),
    howdidyouhearother: yup.string().when('howdidyouhear', {
        is: 'Other',
        then: yup.string().required('How did you hear about us? Please type which is that other option'),
        otherwise:  yup.string()
    })
});
let waitList = yup.object().shape({
    name: yup.string().required('The full name is required'),
    email: yup.string().email('you need to enter a valid email').required('The email is required'),
    telephone: yup.string().matches(phoneRegExp, 'Phone number is not valid').required('The telephone is required'),
    password: yup.string().required('The password is required'),
    guests: yup.string().required('The Guests is required'),
    interest: yup.string().required('The Interest is required'),
    comments: yup.string(),
});
let login = yup.object().shape({
    email: yup.string().email().required(),
    password: yup.string().required(),
});
const validateForm = async (rules, data) => {
    let valid = false;
    await rules.isValid(data).then((result) => {
        valid = result;
    });
    if (!valid)
        await showErrors(rules, data);
    return valid;
};
const showErrors= async (rules, data) => {
    await rules.validate(data,{ abortEarly: false }).catch((err) => {
        showAlertAutoDis({title:`<span style="font-size:25px">Form Validation</span>`,html: `<p  style="font-size:16px">The following error(s) have been found:<br/>${err.errors.join("<br/>")}</p>`});
    });
};
const simpleDateFormat = (date) => {
    const nd = new Date(date);
    return format(nd,"LLL'.'d");
};
const initialState = {
    activeStep: 0,
    activities: {},
    activityDates: [],
    auth:0, //signup=0,login=1
    booking: {},
    bookingType: 'pay', //pay, hold, wait
    calculation: {},
    completed: new Set(),
    customer: {},
    extras: [],
    inquiryData: {},
    inquiryModal:false,
    limitedTo:0,
    loggedIn: false,
    paid:false,
    payModal:false,
    payThisMuch:0,
    payable:false,
    rooms: [],
    selectedActivities:{},
    selectedRooms: [],
    singleOccupancy:false, //Single Occupancy Selected
    skipped: new Set(),
    sources: [{ label: "How did you hear about us?", value: 0 }],
    steps: [],
    terms: false,
    trip: {},
    userInfo:{},
    waitData:{},
};
class BookingForm extends Component {
    constructor(props) {
        super(props)
        this.state = initialState;
    }
    reset() {
        this.setState(initialState);
    }
    async componentDidMount() {
        let statePersisted = sessionStorage.getItem('statePersisted');
        let onBooking = sessionStorage.getItem('onBooking');
        if (statePersisted && onBooking) {
            let {
                trip,
                rooms,
                selectedRooms,
                calculation,
                customer,
                auth,
                userInfo,
                bookingType,
                steps,
                activeStep,
                terms, booking, payable, paid, activities,selectedActivities,
                activityDates, inquiryData,inquiryModal,waitData,sources,payThisMuch,loggedIn,limitedTo,singleOccupancy
            } = JSON.parse(decode(statePersisted));
            if(window['userInfo']){
                userInfo = window['userInfo'];
                auth = 1;
                loggedIn = true;
            }
            const completed = new Set();
            for (let i = 0; i < activeStep; i++)
                completed.add(i);
            this.setState({
                trip,
                rooms,
                selectedRooms,
                calculation,
                customer,
                auth,
                userInfo,
                bookingType,
                steps,
                activeStep,
                terms,
                completed,
                booking, payable, paid, activities,selectedActivities,
                activityDates,inquiryData,inquiryModal,waitData,sources,payThisMuch,loggedIn,limitedTo,singleOccupancy
            });
        } else {
            this.bookingRestart();
        }
    }
    getSources = async () =>{
        const {data} = await requestLoader('booking/hear-options', null);
        const sources = Object.keys(data).map((option) => {
            return {label: data[option], value: option ===""?0:option};
        });
        this.setState({sources})
    }
    getAvailGender = (room) =>{
        let gender = ''
        if(room['roomGuests'].length>0) {
            room['roomGuests'].map(berth => {
                berth['guests'].map(guest => {
                    switch (guest['prefSex']) {
                        case 'M':
                            gender = 'Male';
                            break;
                        case 'F':
                            gender = 'Female';
                            break;
                        case 'x':
                        case '':
                        default:
                            gender = '';
                            break;
                    }
                });
            });
        }
        return gender;
    };
    componentDidUpdate(prevProps, prevState) {
        if (this.state !== prevState) {
            sessionStorage.setItem('statePersisted', encode(JSON.stringify(this.state)));
            sessionStorage.setItem('onBooking', '1');
        }
    }
    bookingRestart = () =>{
        sessionStorage.clear();
        const {trip, userInfo} = window;
        let auth = 0;
        let loggedIn;
        if(userInfo){
            auth = 1;
            loggedIn = true;
        }
        const steps = getStepsBooking();
        let limitedTo=0;
        if('maxPax' in trip && trip['maxPax'])
            limitedTo = parseInt(trip['maxPax']);
        const selectedRooms = trip['rooms'].map((room, index) => {
            limitedTo -= parseInt(room['used']);
            const imageIndex = room['images'].length === 7 ? getRandomInt(0, 6) : 0;
            let roomGuests = [];
            if (room['beds'] && !Array.isArray(room['beds']) && typeof room['beds'] === 'object') {
                roomGuests = Object.keys(room['beds']).filter((berth) => {
                    const bedAvail = room['beds'][berth].filter(bed => {
                        return bed['bookFk'] === null && bed['guestFk'] === "0";
                    });
                    return bedAvail.length>0;
                }).map(berth => {
                    let prefSex = "";
                    const guests = room['beds'][berth].filter(bed => {
                        if(bed['sex']!==null && prefSex==="")
                            prefSex=bed['sex'];
                        else if(bed['sex']!==null && prefSex!=='x' && bed['sex']!==prefSex)
                            prefSex='x';
                        return bed['bookFk'] === null && bed['guestFk'] === "0";
                    }).map(bed=>{
                        return{prefSex,singleOccupancy: false, available:true};
                    })
                    return {berth,guests}
                });
            }
            return {
                cost: room['price']['regular'],
                costPreTax: room['price']['pretax'],
                description: room['description'],
                images: room['images'][imageIndex],
                index: room['index'],
                position: index,
                quantity: 0,
                roomGuests,
                singleOccupancy: false,
                spaces: room['spaces'],
                title: room['title'],
                total: 0,
            };
        });
        const customer = {
            firstName: '',
            lastName: '',
            email: '',
            telephone: '',
            password: '',
            confirmPassword: '',
            howdidyouhear: '',
            howdidyouhearother: '',
            billing_details: {
                address: {
                    city: '',
                    country: '',
                    line1: '',
                    line2: '',
                    postal_code: '',
                    state: ''
                },
                name: '',
                email: '',
                phone: ''
            }
        }
        const inquiryData = {
            name: '',
            email: '',
            phone: '',
            city: '',
            country: '',
            guests: '',
            inquiryType: '',
            interest: '',
            comments: ''
        };
        const waitData = {
            name: '',
            email: '',
            phone: '',
            city: '',
            country: '',
            guests: '',
            interest: '',
            comments: ''
        };
        this.setState({trip, rooms: trip['rooms'], selectedRooms, steps, customer,inquiryData,waitData,userInfo,auth,loggedIn,limitedTo});
    }
    closeModal = () => {
        this.setState({payModal:false});
    };
    showPayModal = () =>{
        this.setState({payModal:true});
    };
    closeInquiryModal = () => {
        this.setState({inquiryModal:false});
    };
    showInquiryModal = () =>{
        this.setState({inquiryModal:true});
    };
    getCalculations = (selectedRooms) => {
        const {trip: {taxRate,SingleSurcharge,length:tripLength,reward:{daysReward,perDay,tripBaseLength,extraDays}},activities,selectedActivities} = this.state;
        //Any other concept of calculation must be here.
        // const parkFee = 65;
        const guestTax = taxRate > 1 ? taxRate - 1 : taxRate;
        const rewardDays = parseFloat(daysReward) + Math.round((tripLength - tripBaseLength) * extraDays);
        const parkfee = rewardDays * perDay;
        const ssc = parseFloat(SingleSurcharge)>1 ? parseFloat(SingleSurcharge)-1:parseFloat(SingleSurcharge);
        const calculation = {taxes: 0, total: 0, subtotal: 0, percent: (guestTax * 100)};
        let quantity = 0;
        const calculatedRooms = selectedRooms.map(room => {
            let total = 0;
            quantity += room.quantity;
            if(room.singleOccupancy && room.quantity > 0)
                total+=(room.costPreTax*ssc);
            calculation.subtotal += total;
            return {...room,total};
        });
        calculation.activitiesAmount=0;
        if (selectedActivities['Complimentary'] && Object.keys(selectedActivities['Complimentary']).length > 0)
            Object.keys(selectedActivities['Complimentary']).map((activity) => {
                if (selectedActivities['Complimentary'][activity] !== '')
                    calculation.activitiesAmount += parseFloat(activities['Complimentary'][activity]['price']);
            });
        if (selectedActivities['Extra'] && Object.keys(selectedActivities['Extra']).length > 0)
            Object.keys(selectedActivities['Extra']).map((activity) => {
                if (selectedActivities['Extra'][activity] !== '')
                    calculation.activitiesAmount += parseFloat(activities['Extra'][activity]['price']);
            });
        calculation.activitiesSubtotal= calculation.activitiesAmount * quantity;
        calculation.quantity = quantity;
        calculation.taxes = calculation.subtotal * guestTax;
        calculation.parkfeeAmount = parkfee;
        calculation.parkfee = quantity*parkfee;
        calculation.total = calculation.subtotal + calculation.taxes + calculation.parkfee + calculation.activitiesSubtotal;
        return {calculatedRooms,calculation};
    };
    validateMaxOccupancy = () => {

        const {limitedTo,selectedRooms,trip} = this.state;
        if('maxPax' in trip && trip['maxPax']){
            let occupancy = 0;
            selectedRooms.map(room => {
                occupancy += room.quantity;
            });
            return limitedTo>occupancy;
        }
        else{
            return true;
        }
    };
    signUpLogin = async () =>{
        let {customer} = this.state;
        let url = 'booking/registerUser';

        await requestLoader(url,{customer},({data})=>{
            if( 'user' in data){

                const userInfo = data['user'];
                // console.log(userInfo);
                if(customer['firstName']==='' && userInfo['firstname'] )
                    customer['firstName'] = userInfo['firstname'];
                if(customer['lastName']==='' && userInfo['lastname'])
                    customer['lastName'] = userInfo['lastname'];
                if(customer['howdidyouhear']==='' && userInfo['howdidyouhear'])
                    customer['howdidyouhear'] = userInfo['howdidyouhear'];
                if(customer['howdidyouhearother']==='' && userInfo['howdidyouhearother'])
                    customer['howdidyouhearother'] = userInfo['howdidyouhearother'];
                if(customer['telephone']==='' && userInfo['phoneday'])
                    customer['telephone'] = userInfo['phoneday'];
                this.setState({userInfo,customer,loggedIn:true});
            }
            else
                showAlertAutoDis({title:'Email Verification',text: `The email ${customer['email']} does not match with any record`});
        });
    };
    setTotalRoom = ({quantity, position}) => {
        // 1. Make a shallow copy of the items
        const {selectedRooms: prevSelectedRooms,rooms} = this.state;
        const selectedRooms = [...prevSelectedRooms];

        selectedRooms[position] = {...selectedRooms[position], quantity};
        const {calculatedRooms,calculation} = this.getCalculations(selectedRooms);

        this.setState({selectedRooms:calculatedRooms, calculation});
    }
    setBookingType = (event) => {
        this.setState({bookingType: event.target.value});
    };
    setCustomer = (event) => {
        const {customer} = this.state;
        this.setState({customer: {...customer, [event.target.name]: event.target.value}});
    };
    setBillingDetails = (event) => {
        const {customer} = this.state;
        this.setState({
            customer: {
                ...customer, billing_details: {
                    ...customer.billing_details,
                    [event.target.name]: event.target.value
                }
            }
        });
    };
    setStep = (activeStep) => {
        this.setState({activeStep});
    };
    setStepBack = () => {
        this.setState(({activeStep}) => {
            if(activeStep>0)
            return {activeStep: activeStep - 1};
        });
    };
    acceptTerms = async (event) => {
        const acceptTerms = event.target.checked;
        const {booking: {bookId}} = this.state;
        if (acceptTerms)
            await requestLoader('booking/accept-terms', {bookId, acceptTerms});
        this.setState({terms: acceptTerms});
    };
    setCompletedStep = () => {
        const {completed, activeStep} = this.state;
        const newCompleted = new Set(completed);
        newCompleted.add(activeStep);

        /**
         * Sigh... it would be much nicer to replace the following if conditional with
         * `if (!this.allStepsComplete())` however state is not set when we do this,
         * thus we have to resort to not being very DRY.
         */
        if (completed.size !== this.totalSteps())
            this.BookingNextStep();
        this.setState({completed: newCompleted});
    };
    completedSteps = () => {
        return this.state.completed.size;
    };
    isStepComplete = (step) => {
        return this.state.completed.has(step);
    }
    totalSteps = () => {
        return this.state.steps.length;
    };
    allStepsCompleted = () => {
        return this.completedSteps() === this.totalSteps();
    };
    setAuth = (value) =>{
        this.setState({auth:value});
    }
    isLastStep = () => {
        return this.state.activeStep === this.totalSteps() - 1;
    };
    resetBooking = () => {
        const active = 0;
        const completed = new Set();
        this.setState({active, completed})
    };
    BookingNextStep = () => {
        const {steps, activeStep, completed} = this.state;
        const newActiveStep = this.isLastStep() && !this.allStepsCompleted()
            ? // It's the last step, but not all steps have been completed
              // find the first step that has been completed
            steps.findIndex((step, i) => !completed.has(i)) : activeStep + 1;
        //When is ready for payment
        // if (newActiveStep === 4)
        //     if (!(booking && Object.keys(booking).length > 0)) {
        //         await this.makeBooking();
        //     }
        this.setState({activeStep: newActiveStep});
    };
    /*isStepOptional = (step) => {
        // if optional step [0,1,2,3,4,5]
        return false;
    };
    handleSkip = () => {
        if (!this.isStepOptional(this.state.activeStep)) {
            // You probably want to guard against something like this
            // it should never occur unless someone's actively trying to break something.
            throw new Error("You can't skip a step that isn't optional.");
        }

        this.setState((state) => {
            const activeStep = state.activeStep + 1;
            const skipped = new Set(state.skipped.values());
            skipped.add(activeStep);
            return {activeStep,skipped};
        });
    };
    skippedSteps = () => {
        return this.state.skipped.size;
    };

    isStepSkipped = (step) => {
        return this.state.skipped.has(step);
    };*/
    allowedPayment = async () =>{
        const paymentData = this.getPaymentData();
        await requestLoader('booking/allowed-payment', paymentData, ({data}) => {
            const {booking:prevBooking} = this.state;
            // console.log(data);
            const {book, message,bookstep,allowed_payment:payable} = data;
            this.setState({booking: {...prevBooking,book,message,bookstep},payable});
        });
    };
    setActivities = async () => {
        const {trip} = this.state;
        const {data:activities} = await requestLoader('booking/get-activities', {trip});
        // console.log(encode(JSON.stringify(data)));
        const selectedActivities = { Complimentary:{}, Extra:{}};
        const activitiesAvail = {Complimentary:{}, Extra:{}};
        const activityDates = [];
        activitiesAvail['Complimentary'] = Object.keys(activities['Complimentary']).filter( (activity) => {
            return activities['Complimentary'][activity]['availabilities'] &&
                (activities['Complimentary'][activity]['availabilities'].length > 0
                    || Object.keys(activities['Complimentary'][activity]['availabilities']).length > 0
                );
        }).map((activity) =>{
            selectedActivities['Complimentary'][activity]='';
            Object.keys(activities['Complimentary'][activity]['availabilities']).map(dates =>{
                let ddate = simpleDateFormat(activities['Complimentary'][activity]['availabilities'][dates]['date']);
                if(activityDates.indexOf(ddate) === -1) {
                    activityDates.push(ddate);
                }
            });
            return activities['Complimentary'][activity];
        });
        activitiesAvail['Extra'] = Object.keys(activities['Extra']).filter( (activity) => {
            return activities['Extra'][activity]['availabilities'] &&
                (activities['Extra'][activity]['availabilities'].length > 0
                    || Object.keys(activities['Extra'][activity]['availabilities']).length > 0
                );

        }).map((activity) =>{
            selectedActivities['Extra'][activity]='';
            Object.keys(activities['Extra'][activity]['availabilities']).map(dates =>{
                let ddate = simpleDateFormat(activities['Extra'][activity]['availabilities'][dates]['date']);
                if(activityDates.indexOf(ddate) === -1) {
                    activityDates.push(ddate);
                }
            });
            return activities['Extra'][activity];
        });
        this.setState({activities:activitiesAvail,selectedActivities,activityDates})
    };
    validateRooms = () => {
        const valid = this.state.selectedRooms.filter(room => room['quantity'] > 0).length > 0;
        if(!valid)
            showAlertAutoDis({title:'Review Booking',text:'No spaces selected, please add space to continue with your booking'});
        return valid;
    }
    getContent = (step) => {
        const {
            selectedRooms,
            bookingType,
            activeStep,
            calculation,
            trip,trip:{feeComment},
            terms,
            customer,
            auth,
            userInfo,
            booking,
            payable, paid, activities, selectedActivities, activityDates,waitData,sources,payThisMuch,loggedIn,singleOccupancy
        } = this.state;
        const {env} = window;
        switch (step) {
            case 0:
                return templateContent(
                    <SelectRoom rooms={selectedRooms} setTotal={this.setTotalRoom}
                                setSingleOccupancy={this.setSingleOccupancy} getAvailGender={this.getAvailGender} singleOccupancy={singleOccupancy} validateMaxOccupancy={this.validateMaxOccupancy}/>,
                    <SummaryContainer selectedRooms={selectedRooms} getAvailGender={this.getAvailGender} calculation={calculation} setTotal={this.setTotalRoom}
                                      showInquiryModal={this.showInquiryModal} validateMaxOccupancy={this.validateMaxOccupancy}
                                      setBooking={this.setBookingType} bookingType={bookingType} step={activeStep}
                                      bookingNext={() => {
                                          if (this.validateRooms())
                                              this.setCompletedStep();
                                      }}/>);
            case 1:
                return templateContent(
                    <Review trip={trip} rooms={selectedRooms} calculation={calculation} setTotal={this.setTotalRoom}
                            validateMaxOccupancy={this.validateMaxOccupancy} feeComment={feeComment}/>,
                    <TripSummary trip={trip} bookingBack={this.setStepBack} feeComment={feeComment} bookingNext={ async () => {
                        if (this.validateRooms()){
                            if(bookingType!=='wait')
                                await this.getSources();
                            if(Object.keys(activities).length===0)
                                await this.setActivities();
                            this.setCompletedStep();
                        }
                    }}
                                 bookingType={bookingType}
                                 bookingOptions={['Continue', 'Go Back to Room Selection']}/>);
            case 2: return templateContent(
                <Activities trip={trip} activityDates={activityDates} activities={activities} selectedActivities={selectedActivities} selectActivity={this.selectActivity}/>,
                <TripSummary trip={trip} bookingBack={this.setStepBack} feeComment={feeComment} calculation={calculation}  bookingNext={async () => {
                    if (this.validateRooms()){
                        this.setCompletedStep();
                    }
                }} itinerary={<Itinerary activities={activities} selectedActivities={selectedActivities} selectActivity={this.selectActivity} activityDates={activityDates} trip={trip}/>}
                             bookingType={bookingType} cancelBooking={this.cancelBooking} bookingOptions={env!=='PRODUCTION'?['Continue', 'Cancel My Reservation','Go Back to Review']:['Continue','Go Back to Review']}/>);
            case 3:
                return templateContent(
                    <ContactForm customer={customer} setCustomer={this.setCustomer} auth={auth} setAuth={this.setAuth} userInfo={userInfo}
                                 setWaitData={this.setWaitData} waitData={waitData} sources={sources} loggedIn={loggedIn}  bookingType={bookingType}/>,
                    <TripSummary trip={trip} bookingBack={this.setStepBack} feeComment={feeComment} calculation={calculation} bookingNext={async () => {
                        const {customer,waitData} = this.state;
                        if (bookingType!=='wait' && this.validateRooms()){
                            if((!loggedIn && await validateForm(auth?login:signup, customer)))
                                await this.signUpLogin();
                            if(this.state.loggedIn && !(this.state.booking && Object.keys(this.state.booking).length > 0))
                                await this.makeBooking();
                        }
                        else if(bookingType==='wait' && await validateForm(waitList, waitData))
                            await this.submitWaitList();
                        if(this.state.booking && Object.keys(this.state.booking).length > 0)
                            this.setCompletedStep();
                    }}
                                 bookingType={bookingType} bookingOptions={['Continue', 'Go Back to Activities']}/>);
            case 4:
                return templateContent(
                    <TermsConditions acceptTerms={this.acceptTerms} checkTerms={terms}/>,
                    <TripSummary trip={trip} bookingBack={this.setStepBack} feeComment={feeComment}  bookingNext={async () => {
                        const {customer,auth} = this.state;
                        if (this.validateRooms() && (loggedIn || await validateForm(auth?login:signup, customer))){
                            if (!(booking && Object.keys(booking).length > 0))
                                await this.makeBooking();
                            await this.allowedPayment();
                            this.setCompletedStep();
                        }
                    }}
                                 bookingType={bookingType} cancelBooking={this.cancelBooking} bookingOptions={env!=='PRODUCTION'?['Continue', 'Cancel My Reservation','Go Back to Activities']:['Continue','Go Back to Activities']}/>);
            case 5:
                return (bookingType === 'pay' ? templateContent(
                    <Payment booking={booking} payThisMuch={payThisMuch} setPayThisMuch={this.setPayThisMuch}/> ,
                    <TripSummary trip={trip} selectedRooms={selectedRooms} feeComment={feeComment} calculation={calculation}
                                 bookingBack={this.setStepBack} bookingNext={async ()=> {
                                     if(bookingType === 'pay' && payable && !paid)
                                        this.showPayModal();
                                     else
                                        this.setCompletedStep()

                    }}
                                 bookingType={bookingType} cancelBooking={this.cancelBooking} bookingOptions={env!=='PRODUCTION'?['Pay Now', 'Cancel My Reservation', 'Go Back to Terms']:['Pay Now', 'Go Back to Terms']}
                                 bookingConfirm={booking}/>)
                    : templateContent(<HoldBook calculation={calculation} booking={booking}/>,
                        <TripSummary trip={trip} selectedRooms={selectedRooms} feeComment={feeComment}
                                     calculation={calculation}
                                     bookingBack={this.setStepBack} bookingNext={async () => {
                            if (bookingType === 'pay' && payable && !paid)
                                this.showPayModal();
                            else
                                this.setCompletedStep();
                        }}
                                     bookingType={bookingType} cancelBooking={this.cancelBooking}
                                     bookingOptions={env!=='PRODUCTION'?['Complete', 'Cancel My Reservation', 'Go Back to Terms']:['Complete', 'Go Back to Terms']}
                                     bookingConfirm={booking}/>));
            case 6:
                return templateContent(<Confirmation bookActivities={this.bookActivities} booking={booking} trip={trip} activityDates={activityDates} activities={activities} cancelBooking={this.cancelBooking} selectedActivities={selectedActivities} selectActivity={this.selectActivity}  />);
            default:
                return 'Unknown step';
        }
    };
    setPayThisMuch = (val) => {
        this.setState({payThisMuch:val.replace(/,/g, '')});
    };
    submitInquiry = async () => {
        const {trip: {tripId},inquiryData:prevData} = this.state;
        const params = {...prevData,tripId};
        await requestLoader('booking/inquiry', params, ({data}) =>{
            // console.log(data);
            if(data && 'title' in data && 'message' in data) {
                this.closeInquiryModal()
                showAlertAutoDis({
                        title: `<span style="font-size:22px">${data.title}</span>`,
                        html: `<h5>${data.message}</h5>`
                    });
                this.reset();
                this.bookingRestart();
            }
        });
        showAlertAutoDis({title:'Inquiry Form Submitted',text:'We\'ve received your request, we\'ll get back to you as soon as possible'});
    };
    submitWaitList = async () => {
        const {trip: {tripId},waitData:prevData} = this.state;
        const params = {...prevData,tripId};
        await requestLoader('booking/waitlist', params, ({data}) =>{
            if(data && 'title' in data && 'message' in data) {
                showAlertAutoDis({
                    title: `<span style="font-size:22px">${data.title}</span>`,
                    html: `<h5>${data.message}</h5>`
                });
                // this.reset();
                // this.bookingRestart();
            }
        });
    };
    setInquiry = (event) => {
        const {inquiryData} = this.state;
        this.setState({inquiryData: {...inquiryData, [event.target.name]: event.target.value}});
    };
    setWaitData = (event) => {
        const {waitData} = this.state;
        this.setState({waitData: {...waitData, [event.target.name]: event.target.value}});
    };
    setSingleOccupancy = (event, room) => {
        let {singleOccupancy} = this.state;
        if((!singleOccupancy && event.target.checked) || (singleOccupancy && !event.target.checked))
            singleOccupancy = event.target.checked;
        let selectedRooms = [...this.state.selectedRooms];
        selectedRooms[room] = {...selectedRooms[room], [event.target.name]: event.target.checked};
        const {calculatedRooms,calculation} = this.getCalculations(selectedRooms);
        this.setState({selectedRooms:calculatedRooms, calculation,singleOccupancy});

    };

    selectActivity = (type, index, value) => {

    // ...selectedActivities[index]
        const {selectedRooms} = this.state;
        let selectedActivities = {...this.state.selectedActivities};
        selectedActivities[type][index] = value;
        this.setState({selectedActivities});
        const {calculatedRooms,calculation} = this.getCalculations(selectedRooms);
        this.setState({selectedRooms:calculatedRooms,calculation});
    };
    getBookingObj = () => {
        const {trip: {tripId},trip, selectedRooms, userInfo, activities, selectedActivities, calculation} = this.state;
        const spaces = {};
        const price = {};
        selectedRooms.map((room) => {
            if(room['singleOccupancy'])
                spaces[room.index] = {'single':1,'shared':room.quantity-1};
            else
                spaces[room.index] = {'single':0,'shared':room.quantity};
            price[room.index] = room.cost;
        });
        return {tripId, trip, spaces, price, userInfo, activities, selectedActivities, calculation};
    };
    makeBooking = async () => {
        const params = this.getBookingObj();
        await requestLoader('booking/create', params, ({data}) => this.setState({booking: data}));
    };
    cancelBooking = async () => {
        const {booking: {bookId}} = this.state;
        await requestLoader('booking/cancel', {bookId}, ({data}) =>{
            if('status' in data && data.status)
                showAlertAutoDis({
                    title:`<span style="font-size:22px">Booking Cancellation</span>`,
                    html:'<h5><strong>Your Book has been canceled!</strong><br/>We\'re sorry you had to cancel it, but we hope to have you on board again</h5>'},
                    ()=>{
                        this.reset();
                        this.bookingRestart();
                });
        });
    };
    getPaymentData = () => {
        const {customer, customer: {billing_details}, booking, bookingType, payThisMuch: amount} = this.state;
        const bookingForm = this.getBookingObj();
        return {
            booking,
            bookingForm,
            bookingType,
            amount: parseFloat(amount).formatMoney(2, '.', ''),
            billing_details: {
                ...billing_details,
                name: `${customer['firstName']} ${customer['lastName']}`,
                email: customer['email'],
                phone: customer['telephone']
            },

        };
    };
    sendStripeToken = async (token) => {
        const paymentData = this.getPaymentData();
        const {
            name,
            brand,
            address_line1,
            address_city,
            address_zip,
            cvc_check,
            address_zip_check,
            country,
            last4
        } = token.card;
        paymentData.cardInfo = {
            name,
            brand,
            address_line1,
            address_city,
            address_zip,
            cvc_check,
            address_zip_check,
            country,
            last4
        };
        paymentData.token= token.id
        paymentData.created = token.created;
        await requestLoader('booking/payment', {paymentData}, ({data}) => {
            const paid = 'paid' in data ? data['paid']:false;
            const state = {booking: {...this.state.booking, book:data['book']},paid,payModal:false};
            this.setState(state);
        });
        this.setCompletedStep();
        // Return and display the result of the charge.
    };
    bookActivities = async () =>{
        const {booking, selectedActivities,userInfo} = this.state;
        const params = {booking,selectedActivities,userInfo};
        await requestLoader('booking/book-activities',params,({data})=>{
            // console.log(data)
            if(data['status'])
                showAlertAutoDis({title:'Activities Confirmed',text:'your Activities have already been booked'},()=>redirectTo('/bookings/view'));
            else
                showAlertAutoDis({title:'Activities Confirmed',text:'There was an error trying to confirm the activities, please contact to our office.'});
        });
    }

    render() {

        const {trip, activeStep, steps,payModal,inquiryModal,inquiryData, calculation, customer,selectedRooms, payThisMuch} = this.state;
        return (
            <ThemeProvider theme={theme}>
                <BookingContainer trip={trip} getContent={this.getContent} activeStep={activeStep} steps={steps}
                                  setStep={this.setStep}
                                  isStepComplete={this.isStepComplete} allStepsCompleted={this.allStepsCompleted} setStepBack={this.setStepBack}/>
                <PaymentModal closeModal={this.closeModal} payModal={payModal} payThisMuch={payThisMuch} calculation={calculation}
                              customer={customer} setBilling={this.setBillingDetails}
                              sendStripeToken={this.sendStripeToken}/>
                <MoreInfoModal inquiryModal={inquiryModal} closeInquiryModal={this.closeInquiryModal}
                               inquiryData={inquiryData} setInquiry={this.setInquiry} selectedRooms={selectedRooms}
                               submitInquiry={this.submitInquiry} trip={trip}/>
            </ThemeProvider>
        );
    }
}

export default BookingForm;

if (document.getElementById('bookingForm')) {
    ReactDOM.render(<BookingForm/>, document.getElementById('bookingForm'));
}
